import { QueryClientScope } from "../types";
import { getCustomerSetting } from "./getCustomerSetting";
import { CustomerSettingsKey, GetCustomerSettingsResponse } from "./types";
import { useQuery } from "@tanstack/react-query";
import { useFeatureToggle } from "src/api/featureToggling/useGetFeatureToggle";
import { FeatureToggleKey } from "src/api";

export const useGetCustomerSetting = (key: CustomerSettingsKey) => {
  const { data: logsDetailedFeature} = useFeatureToggle(FeatureToggleKey.LogsDetailed);
  return useQuery<GetCustomerSettingsResponse, Error>({
    queryKey: [QueryClientScope.CustomerSetting, key],
    queryFn: () => getCustomerSetting(key, logsDetailedFeature?.isEnabled),
    retry: false,
    enabled: key.length > 0,
    staleTime: 5 * 60 * 1000,
  });
};
